import gatherEmail from './gather_email';
import unfocus from './unfocus';
import loadCart from './cart';
import selectVariant from './variants';
import photoCarousel from './carousel';
import initReviews from './product_reviews';
import submitReview from './submit_review';
import searchAutocomplete from './search_autocomplete';
import initSearchPage from './search_page';
import dropdownMenu from './dropdown_menu';
import imageComparison from "./image_comparison";
import './polyfills';

window.addEventListener("DOMContentLoaded", () => {
  window.rambleMaps = window.rambleMaps || {};
  gatherEmail();
  unfocus();
  loadCart();
  selectVariant();
  photoCarousel();
  initReviews();
  submitReview();
  searchAutocomplete();
  initSearchPage();
  dropdownMenu();
  imageComparison();
});

// Once all images are loaded we no longer need the placeholder images, so we
// remove them from the DOM. This makes things cleaner for screen readers.
window.addEventListener("load", () => {
  const placeholders = document.querySelectorAll('img.js_placeholder');
  if (placeholders && placeholders.length) {
    placeholders.forEach(function(placeholder) {
      placeholder.remove();
    });
  }
});
